import React, { useState, useEffect } from 'react';
import {
  Wrapper,
  ShadowBackGround,
  HeaderWrapper,
  Title,
  IconWraper
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { FlashMessage } from '@app/src/common/FlashMessage';

interface Props {
  isOpen: boolean;
  children?: React.ReactNode;
  handleClickOutSide: Function;
  title?: string;
  price?: number;
  message: string;
}

export const AsideModal: React.FC<Props> = ({
  isOpen,
  children,
  handleClickOutSide,
  title,
  price,
  message
}) => {

  const [ isOpenModal, setIsOpenModal ] = useState(isOpen);
  const [ isShowFlash, setIsShowFlash ] = useState(false);

  useEffect(() => {
    setIsOpenModal(isOpen);
    setIsShowFlash(true);
  }, [isOpen]);

  const hideModal = () => {
    setIsOpenModal(!isOpenModal);
    handleClickOutSide && handleClickOutSide(!isOpenModal);
  };

  const handleClickClose = () => {
    setIsShowFlash(false);
  };

  return(
    <React.Fragment>
      <Wrapper transition={isOpenModal}>
        <HeaderWrapper>
          <IconWraper onClick={hideModal}>
            <Icon data-name="icon-close-bold" width="14" height="14" fill="#757575" />
          </IconWraper>
          <Title>
            {title}
            <span>Precio por publicación desde S/ {price}</span>
          </Title>
        </HeaderWrapper>
        <FlashMessage
          message={message}
          isDisplay={isShowFlash}
          isClosable={true}
          handleClickClose={handleClickClose}
        />
        {children}
      </Wrapper>
      <ShadowBackGround onClick={() => hideModal()} transition={isOpenModal} />
    </React.Fragment>
  )
}
